import './journeyProgress.scss';
import StepperDot from './StepperDot';

export default function JourneyProgress(props: any) {
    return (
        <>
            {localStorage.getItem('shortJourney') === "false" && 
                <div className="stepper">
                    <StepperDot page={props.page} stepNo={1}/>
                    <StepperDot page={props.page} stepNo={2}/>
                    <StepperDot page={props.page} stepNo={3}/>
                    <StepperDot page={props.page} stepNo={4}/>
                </div>
            }

            {localStorage.getItem('shortJourney') === "true" &&
                <div className="stepper">
                    <StepperDot page={props.page} stepNo={1}/>
                    <StepperDot page={props.page} stepNo={2}/>
                    <StepperDot page={props.page} stepNo={3}/>
                </div>
            }
           
        </>
    )

}